import TableCellLink from "ds/components/Table/Row/CellLink";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import useAnalytics from "hooks/useAnalytics";

import { IntegrationsAwsUsedByTableCellProps } from "./types";

const IntegrationsAwsUsedByTableNameCell = ({
  item,
  ...cellProps
}: IntegrationsAwsUsedByTableCellProps) => {
  const trackAnalytics = useAnalytics();

  return (
    <TableSimpleCell {...cellProps} role="rowheader">
      <TableCellLink
        href={item.href}
        onPress={() =>
          trackAnalytics("Stack link clicked", {
            name: item.name,
            type: item.type.toLowerCase(),
          })
        }
      >
        {item.name}
      </TableCellLink>
    </TableSimpleCell>
  );
};

export default IntegrationsAwsUsedByTableNameCell;
